import axios from '../../../helpers/custom-axios';
import { notify, confirmation } from '../../../helpers/notifications';

export const createFormMetadata = async (formMetadata) => {
  return axios
    .post('/manage/form_meta_entries', formMetadata)
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const updateFormMetadata = async (formMetadata, id) => {
  // return is slightly different because this call can be made from the FormEdit level
  // and needs to be able to pass along data to child FormMetadata components based on `id`
  return axios
    .put(`/manage/form_meta_entries/${id}`, formMetadata)
    .then((result) => {
      return { id, result };
    })
    .catch((error) => {
      return { id, error };
    });
};

export const deleteFormMetadata = async (id, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/form_meta_entries/${id}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
};
